import { RouteErrorBoundary } from 'es/app/components/layout/RouteErrorBoundary';
import { SiteRouteMap as siteMap } from 'es/app/views/site/RouteMap';
import { lazy } from 'react';
import { Route } from 'react-router';

const TemporalThresholds = lazy(() => import('es/app/views/site/temporal-thresholds/TemporalThresholds'));
const TemporalThresholdDetails = lazy(
    () => import('es/app/views/site/temporal-thresholds/form/details/TemporalThresholdDetails')
);
const TemporalThresholdsForm = lazy(() => import('es/app/views/site/temporal-thresholds/form/TemporalThresholdForm'));
const RecurringThresholds = lazy(
    () => import('es/app/views/site/temporal-thresholds/form/recurring-thresholds/RecurringThresholds')
);
const SpecialThresholds = lazy(
    () => import('es/app/views/site/temporal-thresholds/form/special-thresholds/SpecialThresholds')
);

export function TemporalThresholdRoutes() {
    return (
        <Route
            path={siteMap.temporalThresholds.search()}
            element={<TemporalThresholds />}
            ErrorBoundary={RouteErrorBoundary}
        >
            <Route path={siteMap.temporalThresholds.create().root} element={<TemporalThresholdsForm />}>
                <Route index element={<TemporalThresholdDetails />} />
                <Route
                    path={siteMap.temporalThresholds.create().recurringThresholds}
                    element={<RecurringThresholds />}
                />
                <Route path={siteMap.temporalThresholds.create().specialThresholds} element={<SpecialThresholds />} />
            </Route>
            <Route path={siteMap.temporalThresholds.edit().root} element={<TemporalThresholdsForm />}>
                <Route index element={<TemporalThresholdDetails />} />
                <Route path={siteMap.temporalThresholds.edit().recurringThresholds} element={<RecurringThresholds />} />
                <Route path={siteMap.temporalThresholds.edit().specialThresholds} element={<SpecialThresholds />} />
            </Route>
        </Route>
    );
}
